export default {
      id: "ic_system_coupon-usage",
      viewBox: "0 0 23 24",
      url: "/" + "images/icons.3.109.2.svg#ic_system_coupon-usage",
      toString: function () {
        return this.url;
      }
    }